import { DecimalPipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Store, select } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TeamScoreboardItemModel } from 'models/scoreboards';
import { TeamSettingsModel } from 'models/settings';
import { Subject } from 'rxjs';
import { AppState, playersSelectors } from 'store';

@Component({
    selector: 'app-teams-scoreboard',
    templateUrl: './teams-scoreboard.component.html',
    styleUrls: ['../scoreboard.component.scss'],
    imports: [MatTooltip, DecimalPipe, TranslateModule],
})
export class TeamsScoreboardComponent implements OnInit, OnDestroy {
    private readonly store = inject<Store<AppState>>(Store);

    #unsubscribe = new Subject<void>();
    #items: Array<TeamScoreboardItemModel> = [];
    notQualified: Array<TeamScoreboardItemModel> = [];

    public get items() {
        return this.#items;
    }

    @Input() set items(value: Array<TeamScoreboardItemModel>) {
        if (!value?.length) {
            this.#items = [];
            this.notQualified = [];
            return;
        }
        this.#items = value.filter((x) => x.qualifies);
        this.notQualified = value.filter((x) => !x.qualifies);
    }
    @Input() height: number;
    settings: TeamSettingsModel;

    ngOnInit(): void {
        this.store.pipe(select(playersSelectors.selectSettings)).subscribe((settings) => (this.settings = settings));
    }

    ngOnDestroy(): void {
        this.#unsubscribe.next();
        this.#unsubscribe.complete();
    }
}
